var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container p-0"},[_c('Header',{attrs:{"contentFor":'categories'}}),_c('div',{staticClass:"py-md-4 py-3"},[_c('ListMenu')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }